import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import CountryCodePicker from '../CountryCodePicker';
import TimezoneSwitcher from '../TimezoneSwitcher';
import { timezones } from '../../data/timezones';
const API_URL = process.env.REACT_APP_API_URL;
const AccountDetails = ({ formData: parentFormData, onFormChange }) => {
  const { t } = useTranslation();
  const { user, token } = useAuth();
  
  // Kendi iç state'ini tutmaya devam ediyor
  const [formData, setFormData] = useState({}); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isTimezoneOpen, setIsTimezoneOpen] = useState(false);

  const API_URL_GET = user?.role === 'translator' 
    ? `${API_URL}/api/dashboard/profile` 
    : `${API_URL}/api/auth/me`;

  const API_URL_PUT = `${API_URL}/api/auth/profile/details`;

  useEffect(() => {
    const fetchProfile = async () => {
      if (!token || !user) { setLoading(false); return; }
      try {
        setLoading(true); setError('');
        const response = await fetch(API_URL_GET, { headers: { 'Authorization': `Bearer ${token}` } });
        if (!response.ok) throw new Error(t('error_fetch_profile'));
        const data = await response.json();
        setFormData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, [token, t, API_URL_GET, user]);

 useEffect(() => {
      if (parentFormData) {
          setFormData(parentFormData);
      }
  }, [parentFormData]);


  // Handler'lar artık hem iç state'i hem de üst bileşeni güncelliyor
  const handleChange = (e) => {
    const { name, value } = e.target;
    const newData = { ...formData, [name]: value };
    setFormData(newData); // İç state'i güncelle
    onFormChange({ [name]: value }); // Üst bileşeni bilgilendir
  };

  const handleCountryCodeChange = (code) => {
    const newData = { ...formData, phone_country_code: code };
    setFormData(newData);
    onFormChange({ phone_country_code: code });
  };
  
  const handleTimezoneChange = (tz) => {
    const newData = { ...formData, timezone: tz };
    setFormData(newData);
    onFormChange({ timezone: tz });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(''); setError('');
    
    let submissionData = {
        firstName: formData.first_name, lastName: formData.last_name,
        countryCode: formData.phone_country_code, phone: formData.phone_number,
        timezone: formData.timezone, customerType: formData.customer_type,
        companyName: formData.customer_type === 'kurumsal' ? formData.company_name : null,
    };
    
    if (user.role === 'translator') {
      submissionData = {
          ...submissionData, mainLanguage: formData.main_language,
          country: formData.country, city: formData.city
      };
    }
    try {
      const response = await fetch(API_URL_PUT, { method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }, body: JSON.stringify(submissionData) });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(t(data.messageKey) || t('error_profile_update'));
      }
      setMessage(t('success_profile_updated'));
    } catch (err) {
      setError(err.message);
    }
  };
  
  if (loading || !user) return <div><i className="fas fa-spinner fa-spin"></i> {t('loading_profile')}</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <div className="profile-form-container">
        <h2>{t('account_details')}</h2>
        <form onSubmit={handleSubmit} className="account-details-form">
          <div className="form-row-auth">
            <div className="form-group-auth floating-label half-width">
                <input id="first_name" name="first_name" type="text" value={formData.first_name || ''} onChange={handleChange} required placeholder=" " />
                <label htmlFor="first_name">{t('first_name')}</label>
            </div>
            <div className="form-group-auth floating-label half-width">
                <input id="last_name" name="last_name" type="text" value={formData.last_name || ''} onChange={handleChange} required placeholder=" " />
                <label htmlFor="last_name">{t('last_name')}</label>
            </div>
          </div>
          <div className="form-row-auth">
              <div className="form-group-auth phone-code">
                  {/* DÜZELTME: Eksik label eklendi */}

                  <CountryCodePicker selectedCode={formData.phone_country_code || '+90'} onCodeChange={handleCountryCodeChange} />
              </div>
              <div className="form-group-auth floating-label phone-number">
                  <input id="phone_number" name="phone_number" type="tel" value={formData.phone_number || ''} onChange={handleChange} placeholder=" " /><label htmlFor="phone_number">{t('phone')}</label>
              </div>
          </div>
          <div className="form-group-auth floating-label">
              <input id="email" name="email" type="email" value={formData.email || ''} disabled placeholder=" " /><label htmlFor="email">{t('email_address')}</label>
          </div>

          {user.role === 'customer' && (
            <>
              <div className="form-group-auth">
                  <label className="static-label">{t('local_timezone')}</label>
                  <div className="timezone-display-input" onClick={() => setIsTimezoneOpen(true)}>
                      {formData.timezone || t('select_timezone')}
                  </div>
              </div>
              <div className="form-group-auth customer-type">
                  <label className="static-label">{t('customer_type')}</label>
                  <div className="radio-group">
                      <label className="auth-radio"><input type="radio" name="customer_type" value="bireysel" checked={formData.customer_type === 'bireysel'} onChange={handleChange}/><span>{t('individual_customer')}</span></label>
                      <label className="auth-radio"><input type="radio" name="customer_type" value="kurumsal" checked={formData.customer_type === 'kurumsal'} onChange={handleChange}/><span>{t('corporate_customer')}</span></label>
                  </div>
              </div>
            {formData.customer_type === 'kurumsal' && (
              <div className="form-group-auth floating-label">
                  <input 
                    id="company_name" 
                    name="company_name" 
                    type="text" 
                    value={formData.company_name || ''} 
                    onChange={handleChange} 
                    required // Kurumsal seçiliyse zorunlu
                    placeholder=" " 
                  />
                  <label htmlFor="company_name">{t('company_name')}</label>
              </div>
       
              )}
            </>
          )}

          {message && <p className="auth-success">{message}</p>}
          {error && <p className="auth-error">{error}</p>}
          <button type="submit" className="cta-button">{t('save_changes')}</button>
        </form>
      </div>
      
      <TimezoneSwitcher 
        isOpen={isTimezoneOpen} 
        onClose={() => setIsTimezoneOpen(false)}
        timezones={timezones}
        selectedTimezone={formData.timezone}
        onTimezoneChange={handleTimezoneChange}
      />
    </>
  );
};

export default AccountDetails;